export default "__VITE_ASSET__CwCr0pVX__"